<mat-form-field  class="w-full">
  <mat-label>{{ props.label }}</mat-label>
  <mat-select [formControl]="formControl" [required]="props.required!">
    @for (installation of installations$(); track installation.id) {
    <mat-option [value]="installation">
      {{ installation.name }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>
